<script>
  import loginServico from './servico';
  import radio from '~componentes/Radio.vue';

  export default {
    components: { radio },
    data() {
      return {
        usuario: {},
        tipoDocumento: 'CPF',
        documento: '',
        email:'',
        mostrarErroUsuario: false,
        configuracao: this.$storage.configuracao(),
        etapaLogin: 1,
        emailValidacaoWeb: '',
        codigo: '',
      }
    },
    methods: {
      validar: function () {
       if (this.etapaLogin == 1) {
          this.codigo = '123456'
        }

        this.$validator.validateAll();

        if (this.etapaLogin == 1) {
          this.codigo = ''
        }

        if (!this.errors.any()) {
          this.login()
        }
      },
      login: function () {
        this.mostrarErroUsuario = false;
        this.usuario.login = this.usuario.estrangeiro ? this.email : this.documento;
        this.usuario.aluno = true;
   
        $('.btn').button('loading');

        loginServico
          .aluno(this.usuario)
          .then(resposta => {
             if (resposta.body.token !== "") {
               this.$storage.usuario(resposta.body.usuario);
               this.$storage.token(resposta.body.token);
             }else{
                this.emailValidacaoWeb = resposta.body.emailValidacaoWeb;
                this.etapaLogin = 2;
                $('.btn').button('reset');
             }
          })
          .then(() => {
            if(this.etapaLogin == 1){
              this.$router.push('/');
            }
          })
          .catch(erro => {
            $('.btn').button('reset');
            
            if (erro.status === 404) {
              this.mostrarErroUsuario = true;
              this.usuario.dataNascimento = '';
            } else if (erro.status === 401) {
              this.$swal('', erro.body.message, 'warning');
            } else {
              this.$swal('', 'Ocorreu um erro no login, caso o erro persista entre em contato com a fundação.', 'error');
            }
            this.$router.push('/login/aluno');
          });
      },
      reenviarCodigo() {    
        loginServico.reenviarCodigoValidacao(this.usuario).then(resposta => {
          this.$swal('', resposta.body.message, 'success');

        }).catch(erro => {
            this.mostrarErroUsuario = true;
            this.$swal('', erro.body.message, 'error');
        });
      },
      validarDoisFatores() {
        this.usuario.tokenValidacaoWeb = this.codigo;

        loginServico.verificacaoDuasEtapasPessoaFisica(this.usuario).then(resposta => {
          if (resposta.body.token !== "") {
            this.$storage.usuario(resposta.body.usuario);
            this.$storage.token(resposta.body.token);
          }
        })
          .then(() => {
              this.$router.push('/');           
          }) 
          .catch(erro => {
            $('.btn').button('reset');
            this.$swal('', erro.body.message, 'error');
            this.$router.push('/login/aluno');
          });
      },
      limparDocumento() {
        this.usuario.login = '';
        this.usuario.estrangeiro = this.tipoDocumento != "CPF";
        this.documento = '';
        this.email = '';
        this.$validator.reset();
      }
    },
    watch: {
      'tipoDocumento': 'limparDocumento',
    },
  }
</script>

<template>
  <div>
    <form class="m-t" role="form" @submit.prevent="validar" v-show="etapaLogin == 1">
      <div class="alert alert-danger" role="alert" v-show="mostrarErroUsuario">{{ tipoDocumento }} {{
        !configuracao.acessoAlunoApenasCpf ? ', data de nascimento' : '' }} ou senha estão incorreto(s).</div>

      <div class="form-froup margin-bottom-10">
        <radio v-model="tipoDocumento" selected-value="CPF" type="primary" text-class="text-white" :inline="true"
          class="margin-right-10">
          Pessoa Física
        </radio>
        <radio v-model="tipoDocumento" selected-value="EMAIL" type="primary" :inline="true" text-class="text-white">
          Pessoa Física (Estrangeira)
        </radio>
      </div>

      <div class="row">
        <div class="col-sm-12" v-if="tipoDocumento=='CPF'">
          <div class="form-group required" :class="{ 'has-error': errors.has('documento') }">
            <input type="text" class="form-control" placeholder="CPF" id="documento" data-vv-name="documento"
              data-vv-as="CPF" v-model="documento" v-validate="`required|cpf`" v-mascara="'cpf'">

            <p class="text-danger" v-if="errors.has('documento')">{{ errors.first('documento') }}</p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12" v-if="tipoDocumento=='EMAIL'">
          <div class="form-group required" :class="{'has-error': errors.has('email')}">
            <input type="text" class="form-control" placeholder="Email" id="email" data-vv-name="email"
              data-vv-as="email" v-model="email" v-validate="`required|email`">

            <p class="text-danger" v-show="errors.has('email')">{{ errors.first('email') }}</p>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12">
          <div class="form-group required" :class="{ 'has-error': errors.has('dataNascimento') }"
            v-if="!configuracao.acessoAlunoApenasCpf">
            <input type="text" class="form-control" placeholder="Data de nascimento" v-model="usuario.dataNascimento"
              v-validate="`required|date_format:DD/MM/YYYY`" id="data-nascimento" data-vv-name="dataNascimento"
              data-vv-as="data de nascimento" v-mascara="'data'">

            <p class="text-danger" v-if="errors.has('dataNascimento')">{{ errors.first('dataNascimento') }}</p>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12">
          <div class="form-group" :class="{ 'has-error': errors.has('senha') }">
            <input type="password" class="form-control" placeholder="*******" name="senha" v-model="usuario.senha"
              v-validate="'required'">
            <p class="text-danger" v-if="errors.has('senha')">{{ errors.first('senha') }}</p>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12">
          <button type="submit" class="btn btn-primary block full-width m-b"
                  data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Entrando...">
            Entrar
          </button>

          <router-link to="/recuperar-senha-aluno" class="text-info">
            <i class="fa fa-lock"></i> RECUPERAR SENHA
          </router-link>
        </div>
      </div>

    </form>

    <form id="verificar-forme-dois-fatores" class="m-t" role="form" @submit.prevent="validarDoisFatores" v-show="etapaLogin == 2">

      <div class="text-white form-froup margin-bottom-10">
        <h3>Digite o código de verificação</h3>
      </div>

      <div class="text-white form-froup margin-bottom-10">
        <h5>Um código de verificação foi enviado para o email {{emailValidacaoWeb}}</h5>
      </div>

      <div class="form-group" :class="{ 'has-error': errors.has('codigo') }">
        <input type="text"
               class="form-control"
               name="codigo"
               v-model="codigo"
               maxlength="6"
               id="codigo"
               placeholder="Digite o código de 6 dígitos"
               v-validate="'required'"
               >

        <p class="text-danger" v-if="errors.has('codigo')">{{ errors.first('codigo') }}</p>
      </div>
      <button id="verificarDuasEtapas" type="submit"
              class="btn-verificar btn btn-primary block full-width m-b">
        Verificar
      </button>

      <div class="text-info">
        <div  @click="reenviarCodigo" style="cursor: pointer;">
          <i class="fa fa-repeat"></i> Reenviar Código
        </div>
      </div>
    </form>

  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/login/LoginAluno.vue